/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBillingEntryCleanup extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBillingEntryCleanup");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBillingEntryCleanup.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBillingEntryCleanup>): BackgroundJobPayloadForPeriodicBillingEntryCleanup {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBillingEntryCleanup(), model);
        BackgroundJobPayloadForPeriodicBillingEntryCleanup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBillingEntryCleanup>): BackgroundJobPayloadForPeriodicBillingEntryCleanup {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBillingEntryCleanup.newInstance(<BackgroundJobPayloadForPeriodicBillingEntryCleanup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBillingEntryCleanup) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBillingEntryCleanup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBillingEntryCleanup): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBillingEntryCleanup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
